import React from 'react';
import RoleBasedDashboard from './RoleBasedDashboard';

const Dashboard = () => {
  return <RoleBasedDashboard />;
};

export default Dashboard;